import { GqlService } from '@vw-marketing/myvw-portal-web-utils/Utils/Services/GqlService';

export class FeatureAppService extends GqlService {
  constructor(authService) {
    super(authService);
  }

  async mockUpdateProfileGqlRequest(payload: any) {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Mock User Information saved');

        resolve({ creationStatus: 'USER_INFORMATION_SAVED', payload });
      }, 800);
    });
  }

  async mockSaveSecurityPin(pinObject: { pin: string }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Mock PIN saved', pinObject);
        resolve({
          createSecurityPin: {
            creationStatus: 'SECURITY_PIN_CREATED',
          },
        });
      }, 800);
    });
  }

  async mockUserRegistrationSufficiencyCheck() {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('MOCK USER REGISTRATION SUFFICIENCY CHECK');
        resolve(['profileCreation', 'securityPinCreation']);
      }, 500);
    });
  }

  async mockRemoveAllVehiclesFromUser(userId: string) {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log(
          'MOCK REMOVE ALL VEHICLES FROM USER GQL CALL', userId
        );
        resolve({
          removeAllVehiclesFromUser: {
            status: 'Success',
          },
        });
      }, 1500);
    });
  }

  async mockRemoveVehicleUserAssociation(userID: string) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log(
          'MOCK REMOVE VEHICLE USER ASSOCIATION GQL CALL',
        );
        if (userID === 'test-fail-user') {
          console.error(`Mock error: User configured to always fail`);
          reject(new Error('REMOVE_VEHICLE_ASSOCIATION_ERROR'));
          return;
        }

        console.log('Mock success: Vehicle user association removed');
        resolve({
          removeVehicleUserAssociation: {
            status: 'Success',
            message: 'Vehicle association removed successfully',
          },
        });
      }, 1800);
    });
  }

  async mockSaveUserVehicleNickName(nickname: string) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('MOCK SAVE USER VEHICLE NICKNAME');
        if (!nickname || nickname.trim().length === 0) {
          console.error('Mock error: Nickname cannot be empty');
          reject(new Error('NICKNAME_EMPTY_ERROR'));
          return;
        }

        if (nickname.length > 30) {
          console.error('Mock error: Nickname too long');
          reject(new Error('NICKNAME_TOO_LONG_ERROR'));
          return;
        }

        resolve({
          saveUserVehicleNickName: {
            vehicleId: 'VW-GOLF-GTI-2023-001',
            carNameDesc: nickname.trim(),
          },
        });
      }, 800);
    });
  }
}

export default {
  id: 'myvw:myvw-auth-feature-app-service',

  dependencies: {
    featureServices: {
      'vw:authService': '2.0.0',
      'locale-service': '^1.0.0',
    },
  },

  create: (env) => {
    const provider = env.featureServices['vw:authService'];
    const locale = env.featureServices['locale-service'];
    const countryCode = locale ? locale.countryCode : 'US'
    const faLegalEntity = countryCode === 'CA' ? 'vw-ca-myvw' : 'vw-en-myvw'
    const authService = provider ? provider.register(faLegalEntity) : null;

    return {
      '1.0.0': () => ({
        featureService: new FeatureAppService(authService),
      }),
    };
  },
};
